module.exports = __webpack_public_path__ + "img/box6.f36493f2.png";